<div [ngClass]="type()" class="hint">
  <div class="hint-info-wrapper">
    @if (icon()) {
      <accredible-icon [icon]="icon()" size="20px" />
    }

    @if (image()) {
      <img [src]="image()" alt="" />
    }

    @if (content()) {
      <span [innerHTML]="content()"></span>
    }
    <ng-content select="[hintContent]" />
  </div>

  <ng-content select="[hintAction]" />
</div>
